import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from 'src/app/core/services/app.service';
import { SwalService } from 'src/app/core/services/swal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { ExcelService } from 'src/app/core/services/excel.service';

import { bodyObjects, AgentsBody } from 'src/app/core/shared/body-objects';
import { NgxSpinnerService } from 'ngx-spinner';
import { TabLoadService } from 'src/app/core/services/tab-load.service';
import { LogsFormationComponent } from '../logs-formation.component';
import { InitierFormationsComponent } from '../initier-formations/initier-formations.component';
import { FormationService } from '../../data-access/formation.service';

interface SelectConfig {
  items$: BehaviorSubject<any[]>;
  selected: any[];
  loading: boolean;
  typeahead: Subject<string>;
  page: number;
  searchTerm: string;
}

type SelectKey = 'competences' | 'formations';

@Component({
  selector: 'app-autre-formations',
  templateUrl: './autre-formations.component.html',
  styleUrls: ['./autre-formations.component.scss']
})

export class AutreFormationsComponent implements OnInit {
  bodyObject: AgentsBody = bodyObjects.agents;
  @Output() rowSelected = new EventEmitter<any>();
  @Input() agentRow: any;
  @Input() listFormations: any;

  public formationsForm: FormGroup;
  public typeVisualisation: any;
  public listPriorite: any = [];
  public listAutreFormations: any = [];
  public response: any;
  public typeFiche: any;
  public entretien_id: any;
  public agent_id: any;
  public typeSauvegarde: any;
  public vueActive: any;
  public statut: any;

  public duree_souhaite: string;
  public periode_souhaitee: string;
  public type_formation: any;
  public domaine_formation: any;
  public lieu: any;
  public budget: any;
  public motivation: string;
  public selectedCompetence: any[];
  public mesure_efficacite: any;

  public rowData: any;
  public action: string;
  public p: number = 1;

  public selectedParticipant: any;
  public settingsParticipant = {};
  public listParticipant: any = [];

  public settingsFormation = {};
  public listFormation: any = [];
  public listDomaine: any = [];
  public listType: any = [];
  public listCompetences: any = [];
  public listDemande: any = [];
  public formation_id: any;
  public competence_id: any;
  public nomPrenoms: string;

  startDate: Date;
  endDate: Date;
  isLoading: boolean = false;
  loading = false;
  typeahead = new Subject<string>();
  page = 1;

  errorMessage: string | null = null;

  selectConfigs: Record<SelectKey, SelectConfig>;
  public daterange: any = {};
  public options: any = {
    locale: {
      format: 'DD/MM/YYYY',
      applyLabel: 'Appliquer',
      cancelLabel: 'Annuler',
      fromLabel: 'De',
      toLabel: 'À',
      customRangeLabel: 'Personnalisé',
      weekLabel: 'S',
      daysOfWeek: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      firstDay: 1
    },
    autoApply: false,
    alwaysShowCalendars: false,
  };
  private formationSubscription: Subscription;
  public participantDataLoaded = false;
  public typeDataLoaded = false;
  constructor(
    private storage: LocalStorageService,
    private toastrService: ToastrService,
    private loadingBar: LoadingBarService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _service: AppService,
    private _swal: SwalService,
    private excelService: ExcelService,
    private tabLoadService: TabLoadService,
    private formationService: FormationService,
    private fb: FormBuilder,
  ) {
    this.selectConfigs = {
      competences: this.createSelectConfig(),
      formations: this.createSelectConfig()
    };
  }

  public async exportXls(): Promise<void> {
    this.toastrService.info('La génération de l\'export est en cours');
    if (this.listAutreFormations) {
      const exportData = this.listAutreFormations.map(formation => ({
        'DATE DEMANDE': formation.created_at,
        'REF. DEMANDE': formation.code,
        'CODE': formation.code_competence,
        'INTITULE FORMATION': formation.intitule_formation,
        'DUREE': formation.duree_souhaite,
        'PERIODE': formation.periode_souhaite,
        'LIEU FORMATION': formation.lieu
      }));

      this.excelService.exportAsExcelFile(exportData, 'Liste des formations à la demande');
    } else {
      this.toastrService.warning('Aucune donnée à exporter');
    }
  }

  private createSelectConfig(): SelectConfig {
    return {
      items$: new BehaviorSubject<any[]>([]),
      selected: [],
      loading: false,
      typeahead: new Subject<string>(),
      page: 1,
      searchTerm: ''
    };
  }


  private setupTypeahead(key: SelectKey) {
    const config = this.selectConfigs[key];
    config.typeahead.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(term => {
        config.page = 1; // Réinitialisation de la page à 1 pour une nouvelle recherche
        return this.searchData(key, term);
      })
    ).subscribe(
      data => {
        config.items$.next(Array.isArray(data) ? data : []);
        config.loading = false;
      },
      error => this.handleError(error, key)
    );
  }

  private loadData(key: SelectKey) {
    const config = this.selectConfigs[key];
    config.loading = true;
    this.errorMessage = null;
    const params = this.getParams(key);
    const url = this.getUrl(key);

    this._service.postData(url, params).pipe(
      map(response => this.extractData(response)),
      map(items => items.map(item => ({
        ...item,
        label: `[${item?.code ?? item?.code_stage}] ${item?.libelle}`
      }))),
      catchError(error => this.handleError(error, key))
    ).subscribe((data: any[]) => {
        if (config.page === 1) {
          config.items$.next(data);
        } else {
          config.items$.next([...config.items$.value, ...data]);
        }
        config.loading = false;
      },
      (err) => { this.toastrService.error(err.error.message) }
    );
  }

  private searchData(key: SelectKey, term: string): Observable<any[]> {
    const config = this.selectConfigs[key];
    config.loading = true;
    const params = { ...this.getParams(key), search: term, page: 1 };
    const url = this.getUrl(key);

    return this._service.postData(url, params).pipe(
      map(response => this.extractData(response)),
      map(items => items.map(item => ({
        ...item,
        label: `[${item?.code ?? item?.code_stage}] ${item?.libelle}`
      }))),
      catchError(error => this.handleError(error, key))
    );
  }

  private extractData(response: any): any[] {
    if (response?.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else {
      console.error('API did not return data in expected format:', response);
      return [];
    }
  }

  private getParams(key: SelectKey): any {
    const config = this.selectConfigs[key];
    if (key === 'competences') {
      return { 'campagne_id': this.storage.retrieve('idCampagneEiaSelected'), page: config.page };
    } else if (key === 'formations') {
      return {
        page: config.page,
        type: this.type_formation?.type_stage,
        domaine_formation_id: this.domaine_formation?.id,
        search: config.searchTerm // Nous utiliserons une nouvelle propriété searchTerm
      };
    }
    return { page: config.page };
  }

  private getUrl(key: SelectKey): string {
    if (key === 'competences') {
      return `postes-competences/${key}/all`;
    } else if (key === 'formations') {
      return `gestion-evaluations/formations/catalogue/getCatalogueFormationByTypeAndDomaine`;
    }
    return '';
  }

  private handleError(error: any, key: SelectKey): Observable<any[]> {
    console.error(`Error loading ${key} data`, error);
    const config = this.selectConfigs[key];
    config.loading = false;
    this.errorMessage = `Failed to load ${key} data. Please try again.`;
    config.items$.next([]);
    return of([]);
  }


  public showDetails(skills: any, type: string) {
    const modalRef = this.modalService.open(InitierFormationsComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    modalRef.componentInstance.skills = skills;
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.view = 'formation-demande';
  }

  ngOnDestroy() {
    if (this.formationSubscription) {
      this.formationSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    this.listPriorite = [{ 'label': '1', 'value': 1 }, { 'label': '2', 'value': 2 }]
    this.formationsForm = this.fb.group({
      code: ['', Validators.required],
      libelle: ['', Validators.required],
      formation: ['', Validators.required],
      reference: ['', Validators.required],
      priorite_id: ['', Validators.required],
      periode_souhaitee: ['', Validators.required]
    });
    this.settingsParticipant = {
      singleSelection: false,
      text: 'Sélectionner le (s) participant (s)',
      selectAllText: 'Tout sélectionner',
      unSelectAllText: 'Tout déselectionner',
      classes: 'myclass custom-class',
      labelKey: 'nom_prenoms',
      enableSearchFilter: true,
      searchBy: ['nom_prenoms'],
      searchPlaceholderText: 'Rechercher',
      noDataLabel: 'Aucun participant disponible'
    };

    this.formationSubscription = this.tabLoadService.loadTab$.subscribe(tabId => {
      if (tabId === 'ngb-tab-4') {
        this.loadFormation();
      }
    });
  }

  onDropdownClick(type: 'participant' |'type') {
    const eiaCampagneId = this.storage.retrieve('idCampagneEiaSelected');
    switch (type) {
      case 'participant':

        if (!this.participantDataLoaded) {
          this._service.getData(`gestion-evaluations/formations/${eiaCampagneId}/${this.typeFiche}/getListeParticipant`).subscribe((res) => {
            this.listParticipant = res['data'];
            this.listParticipant.forEach(e => {
              e.nom_prenoms = `[${e?.matricule}] ${e?.nom} ${e?.prenoms}`;
            });
            const matchingParticipant = this.listParticipant.find(p => p?.matricule === this.agentRow?.matricule);

            if (matchingParticipant) {
              this.selectedParticipant = [matchingParticipant];
            }
            this.participantDataLoaded = true;
          });
        }
        break;
      case 'type':

        if (!this.typeDataLoaded) {
          this._service.postData(`gestion-evaluations/formations/catalogue/getAllType`, {}).subscribe((res) => {
            this.listType = res['data'],
              this.listType.forEach(e => { e.label = e?.type_stage});
            this.typeDataLoaded = true;
          })
        }
        break;
    }
  }

  loadFormation() {
    this.nomPrenoms = `${this.agentRow?.qualite || ''} ${this.agentRow?.nom || ''} ${this.agentRow?.prenoms || ''}`.trim();
    this.onDropdownClick('participant');
    this.setupTypeahead('competences');
  }

  public openModal(type: string) {
    const modalRef = this.modalService.open(InitierFormationsComponent, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    modalRef.componentInstance.type = type;
  }

  public recupererData() {
    swal.fire({
      title: 'Action irréversible !!',
      html: '<h4>Vous allez récuperer les données de la fiche simulation pour la rubrique <b>OBJECTIFS ANNEE A+1</b></h4>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#0C8B3E',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, Je confirme',
    })
      .then((result) => {
        if (result.value) {
          this.loadingBar.start();
          this._service
            .getData('gestion-evaluations/fiche/recuperation/' + this.entretien_id + '/formation/simulation')
            .subscribe(
              (res) => {
                if (res.error === false) {
                  this.loadingBar.stop();
                  swal.fire({
                    title: 'HR PERF',
                    type: 'success',
                    text: res.message,
                    showCancelButton: false,
                    confirmButtonText: 'ok',
                  }).then(() => {
                    this.formationService.notifyAllFormations();
                  });
                } else {
                  this.loadingBar.stop();
                  this._swal.error(res.message);
                }
              },
              (err) => {
                this.toastrService.error(err.error.message);
              }
            );
        } else {
          console.log('close');
        }
      });
  }

  public getAllFormations() {
    this.formationService.notifyAllFormations();
  }

  public removeFormations(id: number) {
    swal
      .fire({
        title: 'En êtes vous sûr?',
        text: 'Vous allez supprimer cette formation',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FD7E14',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Oui, je confirme',
      })
      .then((result) => {
        if (result.value) {
          this._service.deleteData(`gestion-evaluations/formations/${id}/normal/delete`)
            .subscribe(
              (res) => {
                if (res.error === false) {
                  this._swal.success(res.message);
                  this.loadingBar.stop();
                  this.formationService.notifyAllFormations();
                } else {
                  this._swal.error(res.message);
                  this.loadingBar.stop();
                }
              },
              (err) => {
                this.toastrService.error(err.error.message);
                this.loadingBar.stop();
              }
            );
        }
      });
  }
}
